import styled from 'styled-components';

export default styled('div')`
  background: #fff;
  padding: 40px 100px;
  margin: 0 auto;
  text-align: center;
  width: 66.6667%;
  border-radius: 2px;
  img {
    margin-bottom: 20px;
  }
  h2 {
    font-size: 25px;
    font-weight: 600;
    color: #0b2f3f;
    margin-bottom: 20px;
  }
  p {
    color: #595959;
    font-size: 16px;
    margin-bottom: 30px;
  }
  button {
    .btn-icon {
      img {
        margin-bottom: 0;
        margin-right: 10px;
        filter: invert(100%) sepia(100%);
      }
    }
    .btn-text {
      font-weight: bold;
    }
  }
  @media only screen and (max-width: 767px) {
    padding: 40px 60px;
    width: 100%;
  }
`;
